import { AutogenModelInsightComments, AutogenRowInsightComments } from "./autogen/AutogenModelInsightComments";

export class ModelInsightComments extends AutogenModelInsightComments<RowInsightComments> {
	constructor() {
		super(RowInsightComments);
	}
}

export class RowInsightComments extends AutogenRowInsightComments {
}